import { Capacitor } from '@capacitor/core';

const APP_UA_TAG = 'MyTownlyRiderApp';

/** Android System WebView (APK) — not Chrome browser */
export const isAndroidWebView = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /Android/i.test(ua) && (/\bwv\b/i.test(ua) || ua.includes(APP_UA_TAG));
};

/** True when running inside the Capacitor Android/iOS shell */
export const isNativeApp = () => {
  try {
    if (Capacitor.isNativePlatform()) return true;
    const platform = Capacitor.getPlatform?.();
    if (platform === 'android' || platform === 'ios') return true;
  } catch {
    /* not in Capacitor */
  }
  if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) return true;
  return isAndroidWebView();
};

/** Use native Firebase phone auth (no web reCAPTCHA) */
export const useNativePhoneAuth = () => {
  try {
    const platform = Capacitor.getPlatform();
    if (platform === 'android' || platform === 'ios') return true;
    if (platform === 'web') return false;
  } catch {
    /* Capacitor unavailable */
  }
  return isAndroidWebView();
};
